export const regulatoryUpdatesKeys = {
  LIST: 'REGULATORY_UPDATES_LIST',
  DETAIL: 'REGULATORY_UPDATE_DETAIL',
};
